import { CarbonCausalChain } from '../ccc-algorithm/carbon-causal-chain/carbon-causal-chain';
import { EvaluatedFactor, Factor } from './factor';

export interface ITransitionElement {
  transitionElement: string;
  version: string;
  unitOfMeasure: string;
  cohort: Factor | EvaluatedFactor;
  type: TransitionElementType;
  props:
    | TransitionElementProps
    | UpshiftUpdateProps
    | ResourceShiftProps
    | ShiftProps
    | SupplyUpdateProps
    | SupplyAlterationProps;
}

export enum TransitionElementType {
  Upshift = 'UPSHIFT',
  Update = 'UPDATE',
  Shift = 'SHIFT',
  ResourceShift = 'RESOURCE_SHIFT',
  SupplyAlteration = 'SUPPLY_ALTERATION',
  SupplyUpdate = 'SUPPLY_UPDATE',
}

export interface UpshiftElement extends ITransitionElement {
  props: UpshiftUpdateProps;
}

export interface UpdateElement extends ITransitionElement {
  props: UpshiftUpdateProps;
}

export interface ResourceShiftElement extends ITransitionElement {
  props: ResourceShiftProps;
}

export interface ShiftElement extends ITransitionElement {
  props: ShiftProps;
}

export interface SupplyAlterationElement extends ITransitionElement {
  props: SupplyAlterationProps;
}

export interface SupplyUpdateElement extends ITransitionElement {
  props: SupplyUpdateProps;
}

export interface TransitionElementProps {
  carbonCausalChains: UpdateCarbonCausalChainOptions;
}

export interface UpshiftUpdateProps extends TransitionElementProps {
  weightInversionExpression: string;
  factorsToUpdate: UpdateFactorOptions[];
}

export interface ResourceShiftProps extends TransitionElementProps {
  resourcesToUpdate: UpdateResourceOptions;
}

export interface ShiftProps {
  shiftFrom: UpdateCarbonCausalChainOptions;
  shiftTo: UpdateCarbonCausalChainOptions;
}

export interface SupplyAlterationProps extends TransitionElementProps {
  maximumPotential?: Factor;
}

export interface SupplyUpdateProps extends TransitionElementProps {
  variableToUpdate: string;
  weightInversionExpression?: string;
}

export interface UpdateFactorOptions {
  update: string;
  by: Factor | EvaluatedFactor;
  type: UpdateType;
}

export enum UpdateType {
  Increase = 'INCREASE',
  Savings = 'SAVINGS',
  EfficiencyImprovement = 'EFFICIENCY_IMPROVEMENT',
}

export interface UpdateCarbonCausalChainOptions {
  atoc: string;
  chains: string[];
}

export interface CarbonCausalChainReference {
  chain: string;
}

export interface UpdateResourceOptions {
  from: string;
  to: string;
}

export interface EvaluatedMechanism {
  atoc: EvaluatedFactor;
  cccIds?: string[];
  cccs?: CarbonCausalChain[];
}
